import React from 'react'

import SubmenuRequestsAndForms from "./requests-and-forms/requests-and-forms"
import ToggleSubmenuButton from "./toggle-button/toggle-button"
import MoreButton_Project from "../../../../../core/gd-ui/more/project/more-button"
import {MoreButtonType} from "../../../../../core/gd-ui/more/types"
import {SESSION_PROJECT_CHANGE} from "../../../../../core/gd/bus/bus-event-type"
import { ViewType } from '../../../../../core/gd/const/views/view-type'
import ProjectSession from "../../../../../core/model2/project/project-session"
import SubmenuItem from "./submenu-item/submenu-item"
import ErrorBoundary from "../../../../../core/error-boundary"
import ProjectMenuMore from "./more-views/more-views"
import AutomationsSubmenuButton from "./automations/automations"
import ProjectSubmenuViewsReorderList from "./views-reorder-list/views-reorder-list"
import ProjectViewFactory from "../../../../../core/model2/project-view/factory"
import ProjectView_Form from "../../../../../core/model2/project-view/views/form/form-view"
import ProjectView from "../../../../../core/model2/project-view/project-view"
import AddView from "./add-view/add-view"
import Project from "../../../../../core/model2/project/project";

// const debug = "ProjectSubmenu"
const debug = false

type Props = {
    project     : ProjectSession
}

export default class ProjectSubmenu extends React.Component<Props> {

    private fullAccess              : boolean = false
    private isStandardAccessUser    : boolean = false
    private isReadOnlyAccessUser    : boolean = false
    private showSeparator           : boolean = false

    private menuInfo                : any
    private requestsAndForms        : any

    constructor(props: Props) {
        super(props)
    }

    componentDidMount() {
        gd.layout.on('change:widthMain', this.onResize, this)
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.onSessionProjectChange)
    }

    componentWillUnmount() {
        gd.layout.off('change:widthMain',this.onResize,this)
        gd.bus.unsubscribe(this)
    }

    onResize = () => {
        this.forceUpdate();
    }

    onSessionProjectChange = (projectId: ID) => {
        debug && console.log(debug, 'onSessionProjectChange', gd.projectViews.project.id === projectId, gd.projectViews.project.id, projectId)
        if (gd.projectViews.project.id === projectId) {
            this.forceUpdate()
        }
    }

    prepareViews = () => {
        // const project   : ProjectSession    = gd.session.projects.get(gd.projectViews.project.id)!
        const project   : ProjectSession    = this.props.project
        const projectId : ID                = gd.projectViews.project.id;

        this.fullAccess                     = gd.ac.check.project.fullAccess(projectId)
        this.isStandardAccessUser           = gd.ac.check.project.standardAccess(projectId)
        this.isReadOnlyAccessUser           = gd.ac.check.project.canReadOnly(projectId)

        this.menuInfo = this.isStandardAccessUser || this.isReadOnlyAccessUser ?
            ProjectViewFactory({systemType: ViewType.PROJECT_INFO}, gd.projectViews)
            :
            null

        if (gd.projectViews?.currentView?.systemType === ViewType.PROJECT_INFO && this.menuInfo) {
            this.menuInfo.isCurrent = true
        }
        const requestsAndFormsEnabled   = (gd.modules.requests.enabled || gd.modules.publicForms.enabled)
        const requestsAndFormsHasAccess = this.isStandardAccessUser || this.isReadOnlyAccessUser

        // check if there is any form in project.properties.forms that is not pinned to project menu
        const pinnedFormsIds            = _(gd.projectViews.models)
            .filter(view=>view.systemType === ViewType.PROJECT_REQUEST_FORMS)
            .map((view: ProjectView_Form)=>view.id)
            .value()
        const unpinnedForms             = _.filter(project.properties.forms, (form: any)=>!pinnedFormsIds.includes(form.id))
        const hasForms                  = !_.isEmpty(unpinnedForms)
        this.requestsAndForms           = (requestsAndFormsEnabled && requestsAndFormsHasAccess && hasForms) ? ProjectViewFactory({systemType: ViewType.PROJECT_REQUEST_FORMS}, gd.projectViews) : null

        debug && console.log(debug, 'preparePinnedViews', pinnedFormsIds, gd.projectViews.models)

        this.showSeparator = this.fullAccess || this.isStandardAccessUser

        let views           : ProjectView[] = []
        let viewsNotFit     : ProjectView[] = []
        let submenuWidth    : number = 20 //20px is submenu position left

        //add all mandatory items
                                        submenuWidth += 76 + 8  //VIEWS 76px width + 8px margin
        if (this.showSeparator)         submenuWidth += 1 + 10  //Separator 1px width + 10px margin
        if (this.menuInfo)              submenuWidth += 56      //INFO 56px width
        if (this.requestsAndForms)      submenuWidth += 134     //REQUESTS & FORMS 134px width
        if (this.isStandardAccessUser)  submenuWidth += 33      //More 33px width
        submenuWidth += 80 // add VieW btn

        let currentViewId: ID | null = null

        debug && console.log(debug, 'prepareViews currentView', gd.projectViews.currentView)

        if (gd.projectViews?.currentView?.showInSubmenu) {
            // add width of currently selected unpinned view, we need to reserve space for it
            submenuWidth += this._getItemWidth(gd.projectViews.currentView?.name, true)
            currentViewId = gd.projectViews.currentView?.id
        }

        debug && console.log(debug, 'prepareViews models', gd.projectViews.models)

        let currentViewIsVisible = false
        _.map(gd.projectViews.models, (projectView)=>{

            // check if this view is currentView
            const isCurrentView = currentViewId === projectView.id

            // current view item width has been already added and no need to calculate and add its width again
            if (!isCurrentView) {
                const name = projectView.name // get visible name
                const isSelected = projectView.id === gd.projectViews.currentView?.id

                // calculate item width
                submenuWidth += this._getItemWidth(name, isSelected)
            }

            // check if item still fits and add it to views or to viewsNotFit if not
            if (submenuWidth < gd.layout.widthMain) {
                views.push(projectView)
                if (isCurrentView) currentViewIsVisible = true // mark that current view is visible
            } else {
                viewsNotFit.push(projectView)
            }
        })

        // if currentView is not among visible views add it as the last one
        // and remove from viewsNotFit
        if (!currentViewIsVisible && currentViewId && gd.projectViews.currentView) {
            views.push(gd.projectViews.currentView)
            _.remove(viewsNotFit, view=>view.id === currentViewId)
        }

        return {views, viewsNotFit}
    }

    _getItemWidth = (name: string, isSelected: boolean, hasChildren: boolean = false) => {
        //prepare div styles
        const styles: any = {textTransform: 'uppercase'}
        if (isSelected) styles.fontWeight = 700

        //calculate item width
        const textWidth = gd.utils.getTextWidth(name, 13, null, styles) + 1; //1 is for fractional values correction;
        const additionalWidth = hasChildren ? 18 + 19/*18px padding + 19px arrow with margin */ : 24/*24px padding */
        let itemWidth = textWidth + additionalWidth
        if (itemWidth > 120) itemWidth = 120
        return itemWidth + 8/*8px margin*/
    }

    render() {
        const {views, viewsNotFit} = this.prepareViews()

        // const project           = gd.projectViews.project
        const project       = this.props.project

        const showForms         = !!this.requestsAndForms
        const showInfo          = !!this.menuInfo && !this.isReadOnlyAccessUser
        const showViewsMore     = !_.isEmpty(viewsNotFit)
        const showNew           = this.fullAccess && project.properties.canHaveViews
        const showAutomation        = this.fullAccess && gd.ac.check.automation.enabled()
        const showProjectMore   = this.isStandardAccessUser

        return (
            <div className="ui5-hmenu menu-underline">

                <ErrorBoundary>
                    <ProjectSubmenuViewsReorderList views       = {views}
                                                    viewsNotFit = {viewsNotFit}
                                                    isReadOnly  = {this.isReadOnlyAccessUser}/>
                </ErrorBoundary>

                {showForms && <SubmenuRequestsAndForms projectView={this.requestsAndForms}/>}
                {showInfo && <SubmenuItem projectView={this.menuInfo} isReadOnly={this.isReadOnlyAccessUser} />}

                {showViewsMore && <ProjectMenuMore projectId={project.id} additionalViews={viewsNotFit}/>}

                <ErrorBoundary>
                    {this.showSeparator && <div className="v-separator"/>}

                    {showNew &&
                        <AddView className="m-r-10" projectId={project.id}/>
                    }

                    {showAutomation && <AutomationsSubmenuButton projectId={project.id}/>}

                    {!this.isReadOnlyAccessUser &&
                        <ToggleSubmenuButton className="m-r-10"/>
                    }

                    {showProjectMore &&
                        <MoreButton_Project project={project} buttonType={MoreButtonType.CONTROL_BUTTON_S28} hint="More" />
                    }

                </ErrorBoundary>
            </div>
        )
    }
}
